<template>
  <div id="DealersFacilityManagement">
    <section>
      <div id="container-center">
        <div class="labelTitle lable">施設検索</div>
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>施設名</th>
              <td><input type="text" v-model="searchConditions.facilityName"/></td>
              <th>郵便番号</th>
              <td><input type="text" v-model="searchConditions.zip" class="search" name="郵便番号" validate="numeric" maxlength="7"/></td>
              <th>都道府県</th>
              <td>
                <select v-model="searchConditions.prefecture">
                    <option value=""/><option value="北海道">北海道</option><option value="青森県">青森県</option><option value="岩手県">岩手県</option><option value="宮城県">宮城県</option><option value="秋田県">秋田県</option><option value="山形県">山形県</option><option value="福島県">福島県</option><option value="茨城県">茨城県</option><option value="栃木県">栃木県</option><option value="群馬県">群馬県</option><option value="埼玉県">埼玉県</option><option value="千葉県">千葉県</option><option value="東京都">東京都</option><option value="神奈川県">神奈川県</option><option value="新潟県">新潟県</option><option value="富山県">富山県</option><option value="石川県">石川県</option><option value="福井県">福井県</option><option value="山梨県">山梨県</option><option value="長野県">長野県</option><option value="岐阜県">岐阜県</option><option value="静岡県">静岡県</option><option value="愛知県">愛知県</option><option value="三重県">三重県</option><option value="滋賀県">滋賀県</option><option value="京都府">京都府</option><option value="大阪府">大阪府</option><option value="兵庫県">兵庫県</option><option value="奈良県">奈良県</option><option value="和歌山県">和歌山県</option><option value="鳥取県">鳥取県</option><option value="島根県">島根県</option><option value="岡山県">岡山県</option><option value="広島県">広島県</option><option value="山口県">山口県</option><option value="徳島県">徳島県</option><option value="香川県">香川県</option><option value="愛媛県">愛媛県</option><option value="高知県">高知県</option><option value="福岡県">福岡県</option><option value="佐賀県">佐賀県</option><option value="長崎県">長崎県</option><option value="熊本県">熊本県</option><option value="大分県">大分県</option><option value="宮崎県">宮崎県</option><option value="鹿児島県">鹿児島県</option><option value="沖縄県">沖縄県</option>
                </select>
              </td>
              <th>担当支店</th>
              <td>
                <select v-model="searchConditions.salesOffice">
                  <option v-for="branch in branchList" :value="branch.code" :key="branch.code">{{ branch.name }}</option>
                </select>
              </td>
            </tr>
          </table>
          <div class="searchButton-area">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
            <b-button class="backbutton is-primary" @click="back">戻る</b-button>
            <b-button class="is-primary addFacility" @click="addFacility">施設追加</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area" v-if="data.length > 0">
          <div>
            <b-table
              :data="data"
              :paginated="true"
              per-page="10"
              pagination-position="both"
              default-sort="user.first_name"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page"
            >
              <template slot-scope="props">
                <b-table-column field="施設名" label="施設名" width="400" class="breakAll">
                  <a @click="edit(props.row)">{{props.row.facilityName}}</a><span v-if="props.row.tempFlag" class="tempRegist" />
                </b-table-column>
                <b-table-column field="担当支店" label="Philips担当支店" width="200" class="breakAll">{{props.row.salesOffice | officeFilter(branchList)}}</b-table-column>
                <b-table-column field="郵便番号" label="郵便番号" width="100" class="breakAll" centered>{{props.row.zip}}</b-table-column>
                <b-table-column field="住所" label="住所" class="breakAll">{{props.row.prefecture}}{{props.row.city}}{{props.row.address1}}{{props.row.address2}}</b-table-column>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    <b-modal
        :active.sync="isComponentModalActive"
        has-modal-card
        trap-focus
        :destroy-on-hide="false"
        :can-cancel="['escape', 'x']"
        aria-role="dialog"
        aria-label="Example Modal"
        aria-modal>
        <div class="modal-card" style="width: 650px;">
            <header class="modal-card-head">
                <p v-if="selectIndex==-1" class="modal-card-title">施設追加</p>
                <p v-else class="modal-card-title">施設編集</p>
            </header>
            <section class="modal-card-body">
                <table>
                    <tr><th>施設名<span class="require" /></th><td><input type="text" v-model="selectData.facilityName" class="edit" name="施設名" validate="required" maxlength="256"/></td></tr>
                    <tr><th>Philips担当支店<span class="require" /></th>
                        <td>
                            <select v-model="selectData.salesOffice" class="edit" name="Philips担当支店" validate="required">
                              <option v-for="office in branchList" :value="office.code" :key="office.code">{{ office.name }}</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                      <th>郵便番号<span class="require"/></th>
                      <td>
                        <input type="text"
                          id="postcode"
                          style="width: 270px;"
                          v-model="selectData.zip"
                          class="edit"
                          :class="{'border-red': invalidPostcode}"
                          name="郵便番号"
                          validate="required|numeric|zip"
                          maxlength="7"
                          :placeholder="postcodePlaceholder"
                          @blur="onZipBlur(selectData.zip, 'digitErrorZip')"
                        />
                        <b-button class="passButton" v-on:click="addressSearch(selectData.zip)">自動入力</b-button>
                        <div v-show="invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                        <div v-show="digitErrorZip" class="text-red">{{ digitErrorZipMessage }}</div>
                      </td>
                    </tr>
                    <tr><th>都道府県<span class="require" /></th>
                        <td>
                            <select v-model="selectData.prefecture" class="edit" name="都道府県" validate="required">
                                <option value=""/><option value="北海道">北海道</option><option value="青森県">青森県</option><option value="岩手県">岩手県</option><option value="宮城県">宮城県</option><option value="秋田県">秋田県</option><option value="山形県">山形県</option><option value="福島県">福島県</option><option value="茨城県">茨城県</option><option value="栃木県">栃木県</option><option value="群馬県">群馬県</option><option value="埼玉県">埼玉県</option><option value="千葉県">千葉県</option><option value="東京都">東京都</option><option value="神奈川県">神奈川県</option><option value="新潟県">新潟県</option><option value="富山県">富山県</option><option value="石川県">石川県</option><option value="福井県">福井県</option><option value="山梨県">山梨県</option><option value="長野県">長野県</option><option value="岐阜県">岐阜県</option><option value="静岡県">静岡県</option><option value="愛知県">愛知県</option><option value="三重県">三重県</option><option value="滋賀県">滋賀県</option><option value="京都府">京都府</option><option value="大阪府">大阪府</option><option value="兵庫県">兵庫県</option><option value="奈良県">奈良県</option><option value="和歌山県">和歌山県</option><option value="鳥取県">鳥取県</option><option value="島根県">島根県</option><option value="岡山県">岡山県</option><option value="広島県">広島県</option><option value="山口県">山口県</option><option value="徳島県">徳島県</option><option value="香川県">香川県</option><option value="愛媛県">愛媛県</option><option value="高知県">高知県</option><option value="福岡県">福岡県</option><option value="佐賀県">佐賀県</option><option value="長崎県">長崎県</option><option value="熊本県">熊本県</option><option value="大分県">大分県</option><option value="宮崎県">宮崎県</option><option value="鹿児島県">鹿児島県</option><option value="沖縄県">沖縄県</option>
                            </select>
                        </td>
                    </tr>
                    <tr><th>市町村区<span class="require" /></th><td><input type="text" v-model="selectData.city" class="edit" name="市町村区" validate="required" maxlength="100"/></td></tr>
                    <tr><th>住所（それ以降の住所）<span class="require"/></th><td><input type="text" v-model="selectData.address1" class="edit" name="住所（それ以降の住所）" validate="required" maxlength="100" ref="address1"/></td></tr>
                    <tr><th>住所（建物名、部屋番号）</th><td><input type="text" v-model="selectData.address2" name="住所（建物名、部屋番号）" maxlength="100"/></td></tr>
                    <tr><th>電話番号<span class="require"/></th><td><input type="text" v-model="selectData.phoneNumber" class="edit" name="電話番号" validate="required" maxlength="20"/></td></tr>
                </table>
            </section>
            <footer class="modal-card-foot">
              <div style="margin:auto;">
                <b-button label="閉じる" @click="close" />
                <b-button label="保存" type="is-primary" @click="save"/>
              </div>
            </footer>
        </div>
    </b-modal>

    </section>
  </div>
</template>
<script>
import {
  invalidNumberMessage,
  postcodePlaceholder,
  digitErrorZipMessage,
} from "@/components/mock/base/const.js";

export default {
  name: "DealersFacilityManagement",
  methods: {
    back: function() {
      this.$router.go(-1);
    },
    doSearch: function() {
      // バリデーションチェック
      var elements = document.getElementsByClassName("search")
      var result = this.selfMadeValidation(elements)
      if(result.isError){
        this.showErrorMessage(result.msg)
        return
      }

      var excuteApi = this.getFacilityManagementListPOST;
      var successCallBack = this.getFacilityManagementListPOSTSuccess;
      var errorCallBack = this.getFacilityManagementListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getFacilityManagementListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      obj.belongsId = this.belongsId
      return client.apis.externalFacilityManagement.getFacilityManagementListPOST({
        body:obj
      });
    },
    getFacilityManagementListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.hasResult = true
      this.isInitial = true
    },
    getFacilityManagementListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    addFacility: function(rowItem) {
        this.selectData = {facilityName:"",salesOffice:null, zip:"",prefecture:"",city:"",address1:"",address2:"",phoneNumber:""}
        this.selectIndex = -1;
        this.isComponentModalActive = true;
        this.digitErrorZip = false;
    },
    edit: function(rowItem) {
        this.selectData = JSON.parse(JSON.stringify(rowItem));;
        this.selectIndex = this.data.indexOf(rowItem);
        this.isComponentModalActive = true;
        this.digitErrorZip = false;
    },
    addressSearch: function(val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return; 
        this.selectData.prefecture  = this.searchTargetAddress.prefecture
        this.selectData.city  = this.searchTargetAddress.city
        this.selectData.address1 = this.searchTargetAddress.town
        this.selectData.address2 = "";

        // QA476 住所設定後フォーカスを移動する
        this.focusMove("address1");
        this.digitErrorZip = false;
      })
    },
    postCodeSearch: function(){
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      this.searchTargetPostCode = ""
    },
    save: async function() {
      // バリデーションチェック
      var elements = document.getElementsByClassName("edit")
      var result = this.selfMadeValidation(elements)

      if(result.isError){
        this.showErrorMessage(result.msg)
        return
      }
      
      var excuteApi = this.setFacilityManagementSavePOST;
      var successCallBack = this.setFacilityManagementSavePOSTSuccess;
      var errorCallBack = this.setFacilityManagementSavePOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    close: function(){
        this.selectData = {facilityName:"",salesOffice:null, zip:"",prefecture:"",city:"",address1:"",address2:"",phoneNumber:""}
        this.selectIndex = -1;
        this.isComponentModalActive = false;
        if(this.hasResult){
          this.doSearch()
        }
    },
    setFacilityManagementSavePOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.selectData));
      // if(this.selectIndex == -1){
      //   // 登録処理
      //   this.selectData
      // } else {
      //   // 更新処理
      //   this.selectData
      // }
      if(!obj.salesOffice){
        delete obj.salesOffice
      }
      return client.apis.externalFacilityManagement.setFacilityManagementSavePOST({
        body:obj
      });
    },
    setFacilityManagementSavePOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result)
      this.$nextTick(() => {
        //DOMが更新された後に呼ばれるコールバック
        this.close();
      })    
    },
    setFacilityManagementSavePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    /**
     * QA476 郵便番号からフォーカスが外れたら桁数に応じて桁数判定フラグを設定する
     * @param zipCode 郵便番号
     * @param flagName 桁数判定フラグ
     */
    onZipBlur(zipCode, flagName) {
      this[flagName] = zipCode.length < 7;
    },
    /**
     * QA476 引数に指定した項目の末尾にフォーカスを移動する
     * @param refName フォーカスをあてる項目定義
     */
    focusMove(refName) {
      this.$nextTick(() => {
        const element = this.$refs[refName];
        if (element) {
          element.focus();
          const length = element.value.length;
          element.setSelectionRange(length, length);
        }
      })
    }
  },
  data() {
    var branchList = this.getBranchOfficeMaster();
    branchList.unshift({});
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    return {
      belongsId: userInfo.belongsId,
      branchList,
      searchConditions: {
        facilityName: "",
        zip: "",
        prefecture: "",
      },
      data: [],
      isPaginated: true,
      isComponentModalActive: false,
      selectData: {
        facilityName: "",
        salesOffice: null,
        zip: "",
        prefecture: "",
        city: "",
        address1: "",
        address2: "",
        phoneNumber:""
      },
      selectIndex: null,
      searchTargetPostCode: "",
      searchTargetAddress: "",
      hasResult: false,
      invalidPostcode: false,
      digitErrorZipMessage,
      digitErrorZip:false,
      isInitial:true,
    };
  },
  filters: {
    officeFilter(value,officeList){
      var target = officeList.find(val => val.code == value)
      if(target){
        return target.name
      }
      return ""
    },
  },
  computed: {
    // 半角数字エラーテンプレートメッセージ
    invalidNumberMessage() {
      return invalidNumberMessage;
    },
    // 郵便番号入力におけるプレースフォルダー
    postcodePlaceholder() {
      return postcodePlaceholder;
    },
  },
  watch: {
    "selectData.zip"(newValue) {
      this.invalidPostcode = isNaN(Number(newValue));
      // QA476 郵便番号自動検索処理
      if (this.selectIndex == -1) {
        this.isInitial = false;
      }
      if (this.isInitial) {
        this.isInitial = false;
        return
      }
      if (!this.invalidPostcode && newValue.length === 7) {
        this.addressSearch(newValue);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.conditionTable th {
  width: 100px;
}
.conditionTable td {
  width: 400px;
}
a {
  text-decoration: underline;
}
.addFacility {
    float: right;
}
.passButton {
  margin-left:5px;
  width:100px !important;
  height:29px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/DealersFacilityManagement.vue